import { Helmet } from 'react-helmet-async'

import { faCheckCircle } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Columns, DashboardModule, LoadingModule,
} from '@domain-group/suit-theme'

import useSmsLog from '@hooks/useSmsLog'
import useSmsLogs from '@hooks/useSmsLogs'

import ListBlankState from '@components/ListBlankState'
import PageHeader from '@components/PageHeader'

import SmsLogTable from '../SmsLogTable'

const PageContent = () => {
  const smsLogsPayload = useSmsLogs({
    filters: {},
    performHttpRequests: true,
  })

  const {
    callbacks: { loadMore },
    canLoadMore,
    filteredSmsLogs,
    filteredSmsLogsCount,
    hasFilteredSmsLogs,
    loading,
  } = smsLogsPayload

  const { urls: { smsLogsIndexUrl } } = useSmsLog()

  return (
    <>
      <Helmet>
        <title>SMS Logs | Realhub</title>
      </Helmet>

      <PageHeader
        activeTabBarItemKey="smsLogs"
        tabBarItems={[
          {
            href: smsLogsIndexUrl,
            icon: faCheckCircle,
            key: 'smsLogs',
            title: 'SMS Logs',
          },
        ]}
        title="SMS Logs"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <LoadingModule loading={loading} times={3} />

            {!loading && !hasFilteredSmsLogs && <ListBlankState />}

            {!loading && hasFilteredSmsLogs && (
              <DashboardModule title="SMS Logs">
                <Box flexDirection="column">
                  <SmsLogTable smsLogs={filteredSmsLogs} />

                  <DashboardModule.LoadMoreFooter
                    callbacks={{ loadMore }}
                    canLoadMore={canLoadMore}
                    entityCount={filteredSmsLogsCount}
                    loading={loading}
                  />
                </Box>
              </DashboardModule>
            )}
          </Columns.Main>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
